<div class="p-grid p-align-start vertical-container mt-1 container-fullsize">

  <div class="p-col-12  p-col-align-start ">

    <div class="box text-center shadow-lg px-5 py-5 mb-2 bg-white rounded basetext">
      <!-- INSTRUÇÃO  parametrizado carregando os dados da base-->

      <div class="text-left text-info ">
        <h4>CANDIDATURA</h4>
      </div>
      <div class="text-justify mb-3">
        <p>{{instrucao}}</p>
      </div>
       <!-- FIM-INSTRUÇÃO -->

       <div class="px-2 pt-3">
        <div class="ui-g ui-fluid" style="font-size:16px;padding:20px">
          <!-- Parte da imagem -->
          <div class="ui-g-12 ui-md-3" style="text-align:center">
            <img *ngIf="preCandidato?.imagem" [attr.alt]="preCandidato.urlImagem" [src]="preCandidato?.imagem" class="img-fluid" alt="Responsive image">
            <img *ngIf="!preCandidato?.imagem" [attr.alt]="preCandidato.urlImagem" src="/assets/img/avatar-sem-imagem.png" class="img-fluid" alt="Responsive image">
          </div>
      
          <!-- Parte das informações -->
          <div class="ui-g-12 ui-md-9">
            <div class="ui-g">
              <div class="ui-g-12 text-justify">
                <h4 class="text-dark mb-3" *ngIf="preCandidato?.nome != null">{{preCandidato?.nome}}</h4>
                <h6 class="text-dark mb-3" *ngIf="preCandidato?.cpf != null"><b>CPF:</b> {{preCandidato?.cpf}}</h6>
                <h6 class="text-dark mb-3" *ngIf="preCandidato?.email != null"><b>E-mail:</b> {{preCandidato?.email}}</h6>
                <h6 class="text-dark mb-3"><b>Cargo:</b> {{cargo}}</h6>
                <div *ngIf="preCandidato?.curriculum != null">
                  <h6 class="text-dark mb-3"><b>Currículo:</b></h6>
                  <div [innerHTML]="preCandidato?.curriculum" class="text-justify"></div>
                </div>
                <br>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--pTooltip="Aceitar termos de condições"-->
      <div>
        <button type="button" class="btn btn-info btn-block btn-lg"
          (click)="voltar()">
          VOLTAR
          <i class="far fa-check-circle"></i>
        </button>
      </div>
    </div>

  </div>
</div>
